import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1033CopyUmlStatus: 'idle',
    startProcess1033CopyUmlError: undefined as any,
    loadUserParamsProcess1033CopyUmlStatus: 'idle',
    loadUserParamsProcess1033CopyUmlError: undefined as any,

    process1033CopyUmlList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1033CopyUml = createAsyncThunk('process1033CopyUmlSlice/startProcess1033CopyUml', async ({ process1033CopyUml }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1033CopyUml/`,
        prepareData(process1033CopyUml),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1033CopyUmlStatus } = getState().process1033CopyUmlSlice
        return startProcess1033CopyUmlStatus !== 'pending'
    }
})

export const loadUserParamsProcess1033CopyUml = createAsyncThunk('process1033CopyUmlSlice/loadUserParamsProcess1033CopyUml', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1033CopyUml/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1033CopyUmlStatus } = getState().process1033CopyUmlSlice
        return loadUserParamsProcess1033CopyUmlStatus !== 'pending'
    }
})

const Process1033CopyUmlSlice = createSlice({
    name: 'process1033CopyUmlSlice',
    initialState,
    reducers: {
        resetstartProcess1033CopyUml: (state) => {
            state.job = undefined
            state.startProcess1033CopyUmlError = undefined
        },
        resetstartProcess1033CopyUmlError: (state) => {
            state.startProcess1033CopyUmlError = undefined
        },
        resetloadUserParamsProcess1033CopyUml: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1033CopyUmlError = undefined
        },
        resetloadUserParamsProcess1033CopyUmlError: (state) => {
            state.loadUserParamsProcess1033CopyUmlError = undefined
        },
        removeFromProcess1033CopyUmlListById: (state, action) => {
            state.process1033CopyUmlList = state.process1033CopyUmlList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1033CopyUmlListByIds: (state, action) => {
            state.process1033CopyUmlList = state.process1033CopyUmlList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1033CopyUmlList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1033CopyUmlStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1033CopyUmlList = []
            state.startProcess1033CopyUmlStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1033CopyUml.pending, (state) => {
            state.startProcess1033CopyUmlStatus = 'pending'
            state.startProcess1033CopyUmlError = undefined
        })
        builder.addCase(startProcess1033CopyUml.fulfilled, (state, action) => {
            state.startProcess1033CopyUmlStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1033CopyUml.rejected, (state, action) => {
            state.startProcess1033CopyUmlStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1033CopyUmlError = action.error.message
            } else {
                state.startProcess1033CopyUmlError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1033CopyUml.pending, (state) => {
            state.loadUserParamsProcess1033CopyUmlStatus = 'pending'
            state.loadUserParamsProcess1033CopyUmlError = undefined
        })
        builder.addCase(loadUserParamsProcess1033CopyUml.fulfilled, (state, action) => {
            state.loadUserParamsProcess1033CopyUmlStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1033CopyUml.rejected, (state, action) => {
            state.loadUserParamsProcess1033CopyUmlStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1033CopyUmlError = action.error.message
            } else {
                state.loadUserParamsProcess1033CopyUmlError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1033CopyUml,
    resetstartProcess1033CopyUmlError,
    resetloadUserParamsProcess1033CopyUml,
    resetloadUserParamsProcess1033CopyUmlError,
    removeFromProcess1033CopyUmlListById,
    removeFromProcess1033CopyUmlListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1033CopyUmlSlice.actions
export default Process1033CopyUmlSlice.reducer
